module.exports = __webpack_public_path__ + "img/favorite_no.727978fb.png";